import React, { useState } from 'react'
import {FaBars , FaTimes } from 'react-icons/fa'
import { Link } from 'react-scroll';


const Navbar = () => {

    const [nav , setNav] = useState(false);

    const links = [
        {
            id : 1,
            link : "Home"
        },
        {
            id : 2,
            link : "About"
        },
        {
            id : 3,
            link : "Portfolio"
        },
        {
            id : 4,
            link : 'Experience'
        },
        {
            id : 5,
            link : "Contact"
        },
    ];

  return (
    <div className='flex justify-between px-4 items-center w-full h-20  text-white bg-black fixed'>
      <div>
        <h1 className='text-5xl font-signature ml-2 '>Pema</h1>
      </div>
      <ul className='hidden md:flex '>
        {
            links.map(({id,link})=>(
                <li 
                key={id} 
                className='px-4 cursor-pointer capitalize font-medium text-gray-500 hover:scale-105 duration-200 '>
                  <Link to={link} smooth duration={500}>{link}</Link>
                  </li>
            ))}
      </ul>
      <div className='cursor-pointer pl-2 z-10 text-gray-500 md:hidden'  onClick={()=>{setNav(!nav)}}>
        {
         nav ? <FaBars size={30}/> : <FaTimes size={30}/>
        }
      </div>

        {
            nav && (                                       //if nav is true
      <ul className='flex justify-center items-center flex-col absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-black to-gray-800 text-gray-500 '>
        {
            links.map(({id,link})=>(
                <li  key={id} 
     className='cursor-pointer capitalize text-4xl py-6 px-4'> 
     <Link to={link} smooth duration={500}
      onClick={()=>{setNav(!nav)}}
     >{link}</Link>
     </li>
            ))
        }
      </ul>
            )
        }


   </div>
  )
}

export default Navbar
